class SmvContact extends HTMLElement {

  constructor() {
    super();
  }


  connectedCallback() {
    const link = this.querySelector('a');
    link.addEventListener('click', (event) => {
      event.preventDefault();
      // event.stopPropagation();
      const target = document.getElementById('contact');
      if (target) {
        target.scrollIntoView({
          "behavior": "smooth",
        });
      }
    });
  }

}

// Define the new web component
if ('customElements' in window) {
  customElements.define('smv-contact', SmvContact);
}
